var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-row',{staticClass:"error--text semi-bold subtitle-1",attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('icon-alert')],1),_c('v-col',[_vm._v(_vm._s(_vm.$t('onboarding.correctMistakes')))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }